module.exports = __webpack_public_path__ + "img/g.0d85f5f5.png";